import * as React from 'react';
import PromoCard from '../../components/PromoCard';

export default () => (
  <PromoCard
    image_url="/images/stats.png"
    title="Get stats on your brew guides"
    subtitle="Learn how people brew your coffee.
    Filtru securely and annonymously creates
    brew guides usage reports."
  />
);
